import React, { useState, useEffect, useCallback, useContext } from 'react';
import { getProjects, getProjectAggregates } from '@lib/api';
import ProjectModal from './ProjectModal';
import { UserContext } from 'components/contexts/UserProvider';
import { useQuery } from '@tanstack/react-query';
// import { Loading } from '@components/atomic/atoms';
import ProjectsListCards from './ProjectsListCards';

const ProjectsList = ({ permissions }) => {
	const {
		userAccess: { isGuestEnteErogante },
	} = useContext(UserContext);
	const [projects, setProjects] = useState(null);
	const [projectsMeta, setProjectsMeta] = useState({});
	const [projectsAggregate, setProjectsAggregate] = useState(null);
	const [projectsAggregateMeta, setProjectsAggregateMeta] = useState({});
	const [showModalProject, setShowModalProject] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	//console.log('projects', projects);

	const handleShowModal = (setShowModal) => setShowModal(true);

	const { data: projectsFromApi, isPending: isPendingSingle } = useQuery({
		queryKey: ['projects', searchTerm],
		queryFn: async () => {
			const response = await getProjects(`?${searchTerm ? `term=${searchTerm}` : 'perPage=5'}`, 'projects');
			return response;
		},
		refetchOnMount: true,
	});

	const { data: projectsAggregateFromApi, isPending: isPendingAggregate } = useQuery({
		queryKey: ['projectsAggregate', searchTerm],
		queryFn: async () => {
			const response = await getProjectAggregates(searchTerm ? `term=${searchTerm}` : '');
			return response;
		},
		refetchOnMount: true,
	});

	const fetchProjects = useCallback(
		async (e) => {
			if (!projectsFromApi || isPendingSingle) return;
			const resp = projectsFromApi;

			if (resp.success) {
				setProjects(resp.data);
				const { data, success, ...restResp } = resp;
				setProjectsMeta(restResp);
			}
		},
		[projectsFromApi, isPendingSingle],
	);

	const fetchProjectsAggregate = useCallback(
		async (e) => {
			if (!projectsAggregateFromApi || isPendingAggregate) return;
			const resp = projectsAggregateFromApi;
			if (resp.success) {
				setProjectsAggregate(resp.data);
				const { data, success, ...restResp } = resp;
				setProjectsAggregateMeta(restResp);
			}
		},
		[projectsAggregateFromApi, isPendingAggregate],
	);

	useEffect(() => {
		fetchProjects();
		fetchProjectsAggregate();
	}, [fetchProjects, fetchProjectsAggregate]);

	useEffect(() => {
		if (refresh) {
			fetchProjects();
			setRefresh(false);
		}
	}, [fetchProjects, refresh]);

	// if (isPendingSingle || isPendingAggregate) return <Loading />;

	return (
		<>
			{/* <DashboardWheelsSection global={true} /> */}

			{/* lista progetti */}
			<ProjectsListCards
				projects={projects}
				projectsMeta={projectsMeta}
				projectsAggregate={projectsAggregate}
				projectsAggregateMeta={projectsAggregateMeta}
				isPendingAggregate={isPendingAggregate}
				isPendingSingle={isPendingSingle}
				setProjects={setProjects}
				setProjectsMeta={setProjectsMeta}
				handleShowModal={handleShowModal}
				setShowModalProject={setShowModalProject}
				searchTerm={searchTerm}
				setSearchTerm={setSearchTerm}
				isGuestEnteErogante={isGuestEnteErogante}
				permissions={permissions}
			/>

			{/* NEW PROJECT */}
			{!isGuestEnteErogante && (
				<ProjectModal
					setRefresh={setRefresh}
					showModalProject={showModalProject}
					setShowModalProject={setShowModalProject}
					permissions={permissions}
				/>
			)}
		</>
	);
};
export default ProjectsList;
